<template>
  <div class="element-flip">
    <ButtonGroup class="row">
      <CheckboxButton 
        class="flip-btn"
        style="flex: 1;"
        :checked="flipV"
        @click="updateFlip({ flipV: !flipV })"
      >
        <span class="flip-content">
          <IconFlipVertically />
          <span class="flip-label">Vertical<br />Flip</span>
        </span>
      </CheckboxButton>
      <CheckboxButton 
        class="flip-btn"
        style="flex: 1;"
        :checked="flipH"
        @click="updateFlip({ flipH: !flipH })"
      >
        <span class="flip-content">
          <IconFlipHorizontally />
          <span class="flip-label">Horizontal<br />Flip</span>
        </span>
      </CheckboxButton>
    </ButtonGroup>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { ImageOrShapeFlip } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import CheckboxButton from '@/components/CheckboxButton.vue'
import ButtonGroup from '@/components/ButtonGroup.vue'

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const flipH = ref(false)
const flipV = ref(false)

watch(handleElement, () => {
  if (handleElement.value && (handleElement.value.type === 'image' || handleElement.value.type === 'shape')) {
    flipH.value = !!handleElement.value.flipH
    flipV.value = !!handleElement.value.flipV
  }
}, { deep: true, immediate: true })

const { addHistorySnapshot } = useHistorySnapshot()

const updateFlip = (flipProps: ImageOrShapeFlip) => {
  if (!handleElement.value) return
  slidesStore.updateElement({ id: handleElement.value.id, props: flipProps })
  addHistorySnapshot()
}
</script>

<style lang="scss" scoped>
.row {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
:deep(.flip-btn) {
  min-height: 72px;
  height: 72px;
  padding: 4px 8px;
}
:deep(.flip-btn .flip-content) {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
:deep(.flip-btn .flip-label) {
  margin-top: 4px;
  line-height: 1.05;
  text-align: center;
}
</style>
